import React, { useContext, useEffect, useState } from "react";
import Header from "../../header";
import { Button, Card, Col, Row, Spinner } from "react-bootstrap";
import PsContext from "../../../context";
import axios from "axios";
import { ServiceUrl } from "../../../utils/serviceUrl";
import { Toast } from "antd-mobile";
import { momentDate, upperCase } from "../../../utils";

const DISABLE_DURATION = 30 * 60;

const TrackOrderStatus = () => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [disabledButtons, setDisabledButtons] = useState({});

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, "0")}:${secs
      .toString()
      .padStart(2, "0")}`;
  };

  // Restore disabled state on page load
  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem("disabledButtons") || "{}");
    const now = Date.now();

    const updated = {};
    Object.keys(stored).forEach((orderNo) => {
      const remaining = Math.floor((stored[orderNo] - now) / 1000);
      if (remaining > 0) updated[orderNo] = { remaining };
    });

    setDisabledButtons(updated);
  }, []);

  // Countdown timer every second
  useEffect(() => {
    const interval = setInterval(() => {
      setDisabledButtons((prev) => {
        const updated = {};
        Object.keys(prev).forEach((orderNo) => {
          const remaining = prev[orderNo].remaining - 1;
          if (remaining > 0) updated[orderNo] = { remaining };
        });

        // Update localStorage each second
        const now = Date.now();
        const stored = {};
        Object.keys(updated).forEach((orderNo) => {
          stored[orderNo] = now + updated[orderNo].remaining * 1000;
        });
        localStorage.setItem("disabledButtons", JSON.stringify(stored));

        return updated;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    setLoader(true);

    const form = new FormData();
    form.append("order_by", context.user.order_no);
    form.append("college_uuid", context.user.college_uuid);
    form.append("student_uuid", context.user.student_uuid);

    axios.post(ServiceUrl.STUDENTS.ONLINE_LIST, form).then((res) => {
      if (res["data"].status == "1") {
        setDataList(res["data"].data);
      } else {
        Toast.show({ content: res["data"].message || "Error" });
      }
      setLoader(false);
    });
  };

  const handleTrackClick = (orderNo) => {
    const expireAt = Date.now() + DISABLE_DURATION * 1000;
    setDisabledButtons((prev) => ({
      ...prev,
      [orderNo]: { remaining: DISABLE_DURATION },
    }));

    // Save expiration timestamp in localStorage
    const stored = JSON.parse(localStorage.getItem("disabledButtons") || "{}");
    stored[orderNo] = expireAt;
    localStorage.setItem("disabledButtons", JSON.stringify(stored));

    // Call your existing function
    TrackData(orderNo);
  };

  const TrackData = (order_no) => {
    setLoader(true);

    const form = new FormData();
    form.append("order_no", order_no);
    form.append("with_template", "1");
    form.append("college_uuid", context.user.college_uuid);

    axios.post(ServiceUrl.STUDENTS.TRACK_PAYMENT, form).then((res) => {
      if (res["data"].status == "1") {
        loadData();
      } else {
        Toast.show({ content: res["data"].message || "Error" });
      }
      setLoader(false);
    });
  };

  return (
    <div>
      <Header title="Track Order Status" backAction={true} />
      <div className="page-content-wrapper mb-4">
        {loader && (
          <div className="text-center py-4">
            <Spinner animation="border" role="status" />
          </div>
        )}
        <div className="container px-0 ">
          {dataList.map((item) => {
            const isDisabled = disabledButtons[item.order_no];
            return (
              <Card key={item.id} className="mt-1">
                <Row>
                  <Col md={6} xs={6} sm={6}>
                    Order No : {item.order_no}
                  </Col>
                  <Col md={6} xs={6} sm={6} className="text-end">
                    {momentDate(item.created_on, "DD-MM-YYYY hh:mm:ss A")}
                  </Col>
                </Row>
                <Row className="mt-1">
                  <Col md={6} xs={6} sm={6}>
                    Semester : {item.semester}
                  </Col>
                  <Col md={6} xs={6} sm={6} className="text-end">
                    Amount : {item.bill_grand_total}
                  </Col>
                </Row>
                <Row className="mt-1">
                  <Col md={6} xs={6} sm={6}>
                    Ref No : {item.payment_ref_id}
                  </Col>
                  <Col md={6} xs={6} sm={6} className="text-end">
                    {item.payment_status == "1" ? (
                      <span className="text-success">
                        {upperCase(item.payment_response)}
                        {!item.payment_uuid && (
                          <Button
                            size="sm"
                            disabled={!!isDisabled}
                            className="ms-1"
                            onClick={() => handleTrackClick(item.order_no)}
                          >
                            {isDisabled
                              ? `Wait ${formatTime(isDisabled.remaining)}`
                              : "Track Bill"}
                          </Button>
                        )}
                      </span>
                    ) : (
                      <span className="text-danger">
                        {!item.payment_response && (
                          <Button
                            size="sm"
                            disabled={!!isDisabled}
                            onClick={() => handleTrackClick(item.order_no)}
                          >
                            {isDisabled
                              ? `Wait ${formatTime(isDisabled.remaining)}`
                              : "Track Status"}
                          </Button>
                        )}
                        {upperCase(item.payment_response)}
                      </span>
                    )}
                  </Col>
                </Row>
              </Card>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default TrackOrderStatus;
